import { render } from "./Updates.vue?vue&type=template&id=27112372&scoped=true"
import script from "./Updates.vue?vue&type=script&lang=js"
export * from "./Updates.vue?vue&type=script&lang=js"

import "./Updates.vue?vue&type=style&index=0&id=27112372&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27112372"]])

export default __exports__